import { render, staticRenderFns } from "./SignupFormSection.vue?vue&type=template&id=6728d4d5&scoped=true"
import script from "./SignupFormSection.vue?vue&type=script&lang=ts"
export * from "./SignupFormSection.vue?vue&type=script&lang=ts"
import style0 from "./SignupFormSection.vue?vue&type=style&index=0&id=6728d4d5&prod&lang=scss&scoped=true"
import style1 from "./SignupFormSection.vue?vue&type=style&index=1&id=6728d4d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728d4d5",
  null
  
)

export default component.exports